import { FormGroup, Label } from 'reactstrap';
import { useFormikContext } from 'formik';
import { sortBy } from 'lodash';
import { MyTeamsQuery, TeamsQuery } from '../../queries';
import {
  useDataTransforms,
  useIsSuperadminRoute,
  useQueryWithMsg,
} from '../../utils/hooks';
import FormTypeahead from '../FormTypeahead';

const getTeams = (data) =>
  (
    data?.teams || // Used for superadmin routes
    data?.me?.teams ||
    []
  ).filter(
    // Used for regular routes
    ({ allowedActions, hasValidSubscription }) =>
      allowedActions.canEdit && hasValidSubscription,
  );

const TeamSelector = ({ showLabels, ...props }) => {
  const { values } = useFormikContext();
  const showAllTeams = useIsSuperadminRoute();
  // Show only the user's teams unless this is a superadmin route.
  const query = showAllTeams ? TeamsQuery : MyTeamsQuery;
  const { msg, data: teamsData } = useQueryWithMsg(query);
  const [teamOptions = [], userHasTeams = false] = useDataTransforms(
    teamsData,
    [
      (data) => [{ name: 'None', id: null }, ...sortBy(getTeams(data), 'name')],
      (data) => getTeams(data).length > 0,
    ],
  );

  return (
    userHasTeams && (
      <FormGroup className="flex-grow-1">
        {showLabels && <Label>Team</Label>}
        <FormTypeahead
          id="team"
          clearTextOnFocus
          name="team"
          label={showLabels && 'Team'}
          labelKey="name"
          options={teamOptions}
          placeholder={msg || 'Select a team...'}
          size="sm"
          selectedOption={values.team}
          {...props}
        />
      </FormGroup>
    )
  );
};

export default TeamSelector;
